module.exports = __webpack_public_path__ + "img/icon-smiley-wholesome.1448f3f.svg";